export const nameColumnStyling = { minWidth: 120 };
